import React, { useState } from 'react';
import OrderProcess from "../../components/OrderProcess";
import Button from "../../components/Button";
import {ReactComponent as AddCardIcon} from '../../components/svgs/addCardIcon.svg'
import {ReactComponent as LinkIcon} from '../../components/svgs/linkIcon.svg'


import CustomerCreationProcess from '../CutomerCreationProcess';
import InputWithAddButton from './InputWithAddButton';
// import Success from '../components/SuccessPage';

const CreateCommercialCustomerForm = ({ isOpen, onClose }) => {
    const [currentPage, setCurrentPage] = useState(1); // Track current page

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleCancel = () => {
    onClose();
  };


  return (
    <>
        <div className={`side-page ${isOpen ? 'open' : ''}`}>
            <section className="create-order-header-section no-background">
                <div className="content">
                    <h2 className="create-order-page-title mt-10">Create Commercial Customer</h2>
                    <p className="create-order-page-subtitle">Fill out these details to proceed</p>
                </div>
               
            </section>
            <div className="modal-body">
          {/* Render different pages based on currentPage */}
          {currentPage === 1 && (
            <CreateCustomer onNextPage={handleNextPage}  onCancel={handleCancel} />
          )}
          {currentPage === 2 && (
            <BusinessDetails onNextPage={handleNextPage} onPrevPage={handlePrevPage} onCancel={handleCancel} />
          )}
          {currentPage === 3 && (
            <BillingInformation onNextPage={handleNextPage} onPrevPage={handlePrevPage} onCancel={handleCancel} />
          )}
        </div>
            
        </div>
    </>
  );
};


// Separate components for each page
const CreateCustomer = ({ onNextPage, onCancel }) => {
  

  const handleSubmit = (event) => {
    // Handle form submission logic
    event.preventDefault();
    console.log('Form submitted');
  };

    return (
        <div>
            <section className="order-process-section commercial-customer-creation-process">
                <CustomerCreationProcess orderDetails={true} payment={false} completeOrder={false}/>
            </section>

            <form action="" className='create-customer-form-expanded commercial-customer-form flex flex-col gap-10 mt-72' onSubmit={handleSubmit}> 
                <section className='flex gap-10'>
                    <div className='flex flex-col'>
                        <label htmlFor="">First name</label>
                        <input type="text" placeholder='Enter first name' className='mt-2'/>
                    </div>
                    <div className='flex flex-col'>
                        <label htmlFor="">Last name</label>
                        <input type="text" placeholder='Enter last name' className='mt-2' />
                    </div>
                </section>

                <section className='flex gap-10'>
                    <div className='flex flex-col'>
                        <label htmlFor="">Phone number</label>
                        <input type="text" placeholder='Enter phone number' className='mt-2'/>
                    </div>
                    <div className='flex flex-col'>
                        <label htmlFor="">Email address</label>
                        <input type="text" placeholder='Enter email' className='mt-2'/>
                    </div>
                </section>

                <section className=''>
                    <div className='flex flex-col'>
                        <label htmlFor="">Add customer preferences</label>
                        <textarea type="text" placeholder='Enter first name' className='mt-2'/>
                    </div>
                </section>

                <section className=''>
                    <div className='flex flex-col'>
                        <label htmlFor="">Notes</label>
                        <textarea type="text" placeholder='Add additional notes' className='mt-2'/>
                    </div>
                </section>
                <section className="mt-4 create-order-cta-section">
                    <div className="create-order-divider"></div>
                    <section className="flex create-order-cta mt-10">
                        <Button onClick={onCancel} style={{'background': 'none', 'color': '#434C5A', 'fontWeight': '400'}} >Cancel Order</Button>
                        <Button onClick={onNextPage}>Next</Button>
                        
                    </section>
                </section>
            </form>

            
            
        </div>
    );
  };
  
  const BusinessDetails = ({ onNextPage, onPrevPage, onCancel }) => {

    return (
      <div>
        <section className="order-process-section payment-process">
            <OrderProcess orderDetails={false} payment={true} completeOrder={false}/>
        </section>
        <section className='payment-form create-commercial-customer-business-details flex flex-col gap-4'>

            <div className='flex flex-col'>
                <label htmlFor="">Business name</label>
                <input type="text" placeholder='Enter business name' className='mt-2'/>
            </div>
            <div className='flex flex-col'>
                <label htmlFor="">Business Address</label>
                <textarea type="text" placeholder='Enter business address' className='mt-2'/>
            </div>
            <div className='flex flex-col'>
                <label htmlFor="">Does this business have multiple properties?</label>
                <div className='flex gap-20 mt-4'>
                    <button type='radio' style={{display: 'flex'}}><span className='ml-10 property-radio-btn'> Yes</span></button>
                    <button type='radio' style={{display: 'flex'}}> <span className='ml-10 property-radio-btn'> No</span></button>
                </div>
                
            </div>
            <div>
                <InputWithAddButton />
            </div>
            <div className='flex flex-col'>
                <label htmlFor="">Additional Notes</label>
                <textarea type="text" placeholder='Add additional notes' className='mt-2'/>
            </div>
        </section>
        {/* Form elements for Page 2 */}
        <section className="create-order-cta-section create-cpmmercial-customer-cta-section-pg2">
            <div className="create-order-divider"></div>
            <section className="flex mt-10 create-order-cta">
               
                <Button onClick={onCancel} style={{'background': 'none', 'color': '#434C5A', 'fontWeight': '400'}}>Cancel Order</Button>
                <div className='mr-10 next-back-btn-section'>
                    <Button style={{'background': '#F1F9FD', 'color': '#529FBE', 'fontWeight': '400', 'marginRight': '20px'}} onClick={onPrevPage}>Back</Button>
                    <Button onClick={onNextPage}>Next</Button>
                    </div>
            </section>
        </section>
        
      </div>
    );
  };
  
  const BillingInformation = ({ onNextPage, onPrevPage, onCancel}) => {
    return (
      <>
        <section className="order-process-section complete-order-page">
            <OrderProcess orderDetails={false} payment={false} completeOrder={true}/>
        </section>
        <section className='order-summary-section flex flex-col gap-8'>
            <section className=''>
                <div className='saved-cards-flag'>
                    <p className='saved-cards-flag-text'>No saved credit cards</p>
                </div>
                <div className='flex mt-10 gap-10'>
                    <div className='flex gap-4'>
                        <AddCardIcon/>
                        <p className='add-card-section-text'>Add card with Terminal</p>
                    </div>
                    <div className='flex gap-4'>
                        <LinkIcon/>
                        <p className='add-card-section-text'>Add card with Link</p>
                    </div>
                </div>
                </section>
            </section>
            <section className="mt-4 create-order-cta-section">
                <div className="create-order-divider"></div>
                <section className="flex mt-10 create-order-cta">
                    <Button onClick={onCancel} style={{'background': 'none', 'color': '#434C5A', 'fontWeight': '400'}}>Cancel Order</Button>
                    <div className='next-back-btn-section-order-summary'>
                        <Button style={{'background': '#F1F9FD', 'color': '#529FBE', 'fontWeight': '400'}} onClick={onPrevPage}>Back</Button>
                        <Button onClick={onCancel} style={{'marginLeft': '30px'}}>Complete</Button>
                        </div>
                </section>
            </section>
      </>
    );
  };
  
//   const Success = ({ onNextPage, onPrevPage }) => {
//     return (
//       <div>
//         <h3>Page 4</h3>
       
//         <section className="mt-4 create-order-cta-section">
//             <div className="create-order-divider"></div>
//             <section className="flex mt-20 create-order-cta">
//                 <Button style={{'background': 'none', 'color': '#434C5A', 'fontWeight': '400'}} onClick={onPrevPage}>Back</Button>
//                 <Button onClick={onNextPage}>Next</Button>
                
//             </section>
//         </section>
//       </div>
//     );
//   };




export default CreateCommercialCustomerForm;
